import type { EVPData } from '../../../schema/types.ts'

export default function canBePersonalized(data: EVPData[]) {
    // Need to find the strike zone data and all be equivalent to be personalized
    if (!data.length) {
        // console.warn('No Data')
        return false
    }

    // This is a temporary place to find the sz data
    const { szBot, szTop, szWidth, szDepth } = data[0]

    if (
        szBot === undefined ||
        szTop === undefined ||
        szBot === null ||
        szTop === null
    ) {
        return false
    }

    return data.every(
        (d) =>
            d.szBot === szBot &&
            d.szTop === szTop &&
            d.szWidth === szWidth &&
            d.szDepth === szDepth
    )
}
